import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './styles.scss';

const propTypes = {
    list: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string,
            value: PropTypes.node,
        }).isRequired,
    ).isRequired,
};

const defaultProps = {
    key: '',
    node: <span />,
};

@CSSModules(styles, { allowMultiple: true })
export default class KeyValueList extends React.PureComponent {
    static propTypes = propTypes;
    static defaultProps = defaultProps;

    render() {
        const { list } = this.props;

        return (
            <div>
                {
                    list.map(item => (
                        <div
                            key={item.key}
                            styleName="item"
                        >
                            <div styleName="key">{item.key}</div>
                            <div styleName="value">{item.value}</div>
                        </div>
                    ))
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/topic/Announcements/components/KeyValueList/index.js